// @mui
import Fab from '@mui/material/Fab'
import Tooltip from '@mui/material/Tooltip'
// eslint-disable-next-line import/no-extraneous-dependencies
import { keyframes } from '@emotion/react'
// components
import Iconify from 'src/components/iconify'

// ----------------------------------------------------------------------

// Pulso suave para chamar atenção (anel que expande e some).
const pulse = keyframes`
  0%   { box-shadow: 0 8px 20px rgba(124,58,237,0.45), 0 0 0 0 rgba(192,38,211,0.45); }
  70%  { box-shadow: 0 8px 20px rgba(124,58,237,0.45), 0 0 0 16px rgba(192,38,211,0); }
  100% { box-shadow: 0 8px 20px rgba(124,58,237,0.45), 0 0 0 0 rgba(192,38,211,0); }
`

// Balão flutuante no canto inferior esquerdo que abre o painel da Zenvia
// em uma nova aba. (O embed em iframe não é possível: app.zenvia.com envia
// X-Frame-Options: SAMEORIGIN, que o navegador bloqueia.)
export default function ZenviaFab() {
  // Em fase de teste: o balão só aparece em DESENVOLVIMENTO (localhost).
  // No site publicado (build de produção) ele não é renderizado.
  if (process.env.NODE_ENV !== 'development') return null

  return (
    <Tooltip title='Atendimento Zenvia' placement='right' arrow>
      <Fab
        aria-label='Abrir Zenvia'
        onClick={() => window.open('https://app.zenvia.com/', '_blank', 'noopener,noreferrer')}
        sx={{
          position: 'fixed',
          bottom: 24,
          left: 24,
          zIndex: (theme) => theme.zIndex.speedDial,
          width: 62,
          height: 62,
          color: '#fff',
          background: 'linear-gradient(135deg, #7C3AED 0%, #C026D3 100%)',
          animation: `${pulse} 2.6s ease-out infinite`,
          transition: 'transform .2s ease, filter .2s ease',
          '&:hover': {
            transform: 'scale(1.08)',
            filter: 'brightness(1.08)',
            background: 'linear-gradient(135deg, #6D28D9 0%, #A21CAF 100%)',
          },
          '&:active': {
            transform: 'scale(0.96)',
          },
        }}
      >
        <Iconify icon='solar:chat-round-dots-bold' width={30} />
      </Fab>
    </Tooltip>
  )
}
